import { relativeDate } from 'libs/utils/date';
export const ACTION_CALLBACK_ROUTE_COOKIE = 'action_callback_route';
export const ANON_ID_COOKIE_EXPIRATION_DATE = relativeDate({
  years: 20
}); // matches rails's `cookie.permanent`

export const ANON_ID_COOKIE_NAME = 'anon_id';